import { RecipeStatus } from "./recipe";

export interface Retail {
  id: string;
  recipeState: RecipeStatus;
  amount: string;
  patientId: string;
  patientName: string;
  patientSex: number;
  operateUser: string;
  operateTime: string;
  paymentId: string;
}

export function fromJson(
  json: { id?: number; patientId?: number; paymentId?: number } & Record<
    string,
    never
  >
): Retail {
  return {
    id: json.id?.toString() || "",
    recipeState: json.recipeState,
    amount: json.amount,
    patientId: json.patientId?.toString() || "",
    patientName: json.patientName,
    patientSex: json.patientSex,
    operateUser: json.operateUser,
    operateTime: json.operateTime,
    paymentId: json.paymentId?.toString() || "",
  };
}
